// ----------------------------------------------------------------------
// <copyright file="Izenda.ProvisionMapDataStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var action = require('mobx').action;
  var databaseSetupDataFetcher = require('fetchers/Izenda.DatabaseSetupDataFetcher');
  var systemSettingFetcher = require('fetchers/Izenda.SystemSettingFetcher');  
  var notificationFetcher = require('fetchers/Izenda.NotificationFetcher');
  var { MESSAGES } = require('logic/data/Izenda.NotificationConstants');
  var uiState = require('./Izenda.UiState');
  var { get } = require('lodash/fp');
  var AppGlobalConstants = require('logic/data/Izenda.AppGlobalConstants');
  var CommonMessages = require('share/messages/Izenda.CommonMessages');
  var PROVISIONING_STATUS = AppGlobalConstants.PROVISIONING_STATUS;
  var PROVISION_DATA_NOTIFICATION_MESSAGE_KEY = require('logic/data/Izenda.ReportPartMapConstants')
    .PROVISION_DATA_NOTIFICATION_MESSAGE_KEY;
  var MESSAGE_TYPE = CommonMessages.MESSAGE_TYPE;
  var PROVISION_MAP_DATA = CommonMessages.PROVISION_MAP_DATA;
  function ProvisionMapDataStore() {}

  ProvisionMapDataStore.prototype.importMapData = function() {
    return databaseSetupDataFetcher.provisionStaticData().then(
      action(function(result) {
        uiState.setProvisioningStatus(result);

        notificationFetcher
        .addNotification({ notificationMessageID: MESSAGES.PROVISION_MAP_STARTED.id })
        .then(() => {
          uiState.setUpdateNotifications();
        });

        return result;
      })
    );
  };

  ProvisionMapDataStore.prototype.getProvisioningStatus = function() {
    const { provisionStaticDataStatus } = databaseSetupDataFetcher;
    const { loadGoogleMapConfiguration } = systemSettingFetcher;
    return Promise.all([loadGoogleMapConfiguration(uiState.tenantId), provisionStaticDataStatus()]).then(
      action(result => {
        const googleAiKey = get('googleAPIKey', result[0]);
        uiState.setGoogleApiKey(googleAiKey);
        uiState.setProvisioningStatus(result[1]);
        return result[1];
      })
    );
  };
  module.exports = new ProvisionMapDataStore();
})();



// WEBPACK FOOTER //
// ./ui/logic/Izenda.ProvisionMapDataStore.js